/**
 * ISO 639-1 Language Code
 */
export var Region;
(function (Region) {
    Region["jp"] = "jp";
    Region["th"] = "th";
    Region["my"] = "my";
    Region["id"] = "id";
    Region["ph"] = "ph";
    Region["vn"] = "vn";
    Region["us"] = "us";
    Region["gb"] = "gb";
    Region["sg"] = "sg";
})(Region || (Region = {}));
export const RegionDisplayMap = {
    [Region.jp]: '日本',
    [Region.th]: 'ไทย',
    [Region.my]: 'Malaysia',
    [Region.id]: 'Indonesia',
    [Region.vn]: 'Việt Nam',
    [Region.us]: 'US',
    [Region.gb]: 'UK',
    [Region.sg]: 'Singapore',
    [Region.ph]: 'Philippines',
};
export const getRegionIDC = (region) => {
    return [Region.jp, Region.us, Region.gb].includes(region) ? 'va' : 'sg';
};
//# sourceMappingURL=region.js.map